import { VariantProps, cva, cx } from 'cva';

interface BadgeProps extends VariantProps<typeof badge> {
  children: string;
}

const badge = cva({
  base: [
    'relative w-fit whitespace-nowrap rounded-md border px-3 py-[0.1875rem] text-[0.8125rem] font-semibold leading-6'
  ],
  variants: {
    intent: {
      primary: ['border-dashed border-[rgba(47,48,55,0.20)]'],
      secondary: ['border-dashed border-[rgba(255,255,255,0.20)] text-white']
    }
  }
});

export function PricingBadge({ children, intent = 'primary' }: BadgeProps) {
  return (
    <div className={badge({ intent })}>
      {children}{' '}
      <span className="text-[0.625rem] font-normal text-tertiary">/mo</span>
    </div>
  );
}
